import React, {Component} from 'react';

import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';

import InstitutionsAll from './institutions';


class Institutions extends Component {
  render() {
    return (
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/institutions">Установи</Link></li>
          </Breadcrumbs>
        <InstitutionsAll/>
      </div>
    )
  }
}

export default Institutions;



// WEBPACK FOOTER //
// ./src/admin/institutions/index.js